import { ErrorPage } from "../components/ErrorPage"
import { useDocumentTitle } from "../useDocumentTitle"

/**
 * The five `(auth)/errors/*` screens, ported from business-v2. Each wraps the
 * shared `ErrorPage` with its status code / title / copy (verbatim from the
 * Next source). `export const metadata` dropped; `document.title` set via
 * `useDocumentTitle`.
 */

export function ForbiddenPage() {
  useDocumentTitle("403 Forbidden · Badminton Warriors")
  return (
    <ErrorPage
      code="403"
      title="Forbidden"
      description="Access to this resource is forbidden. You don't have the necessary permissions to view this page."
    />
  )
}

export function UnauthorizedPage() {
  useDocumentTitle("401 Unauthorized · Badminton Warriors")
  return (
    <ErrorPage
      code="401"
      title="Unauthorized"
      description="You don't have permission to access this resource. Please sign in or contact your administrator."
    />
  )
}

export function NotFoundPage() {
  useDocumentTitle("404 Not Found · Badminton Warriors")
  return (
    <ErrorPage
      code="404"
      title="Page Not Found"
      description="The page you are looking for doesn't exist or has been moved to another location."
    />
  )
}

export function InternalServerErrorPage() {
  useDocumentTitle("500 Internal Server Error · Badminton Warriors")
  return (
    <ErrorPage
      code="500"
      title="Internal Server Error"
      description="Something went wrong on our end. We're working to fix the issue. Please try again later."
    />
  )
}

export function UnderMaintenancePage() {
  useDocumentTitle("503 Under Maintenance · Badminton Warriors")
  return (
    <ErrorPage
      code="503"
      title="Under Maintenance"
      description="The service is currently unavailable. Please try again later."
    />
  )
}
